// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__G0pXC","row":"Search_row__vhHde","col":"Search_col__YX3TH"};